import {User} from './user';

/**
 * Created by juan on 07/03/17.
 */
export class View {

    id: number = null;

    /** segmentos de la ruta a la vista */
    public route: string[] = ['/'];

    /** fxname de las fx que requiere la vista */
    public requires: string[] = [];

    public menuEntryId: number = null;

    constructor(value: Object = {}) {
        Object.assign(this, value);
    }

    /**
     * Determina si el usuario tiene acceso a esta vista.
     * @param user
     * @returns {boolean}
     */
    public hasAccess(user: User): boolean {
        return this.requires.every(rfx => user.fxs.some(ufx => ufx.fxname == rfx))
    }
}

export const views: View[] = [
    new View({id: 1, route: [''], menuEntryId: 1}),
    // new View({id: 21, route: ['abogados'], requires: ['Abogado.FIND'], menuEntryId: 14}),
    new View({id: 29, route: ['abogados-profiles'], menuEntryId: 20}),
    new View({
        id: 22, route: ['user-requests'],
        requires: ['UserRequest.GETALL', 'UserRequest.REJECTREQUEST', 'UserRequest.APPROVEREQUEST'], menuEntryId: 17
    }),
    new View({id: 2, route: ['users'], requires: ['User.FIND'], menuEntryId: 3}),
    new View({id: 3, route: ['users', ':number'], requires: ['User.UPDATE', 'Role.FINDALL']}),
    new View({id: 4, route: ['users', 'new'], requires: ['User.CREATE', 'Role.FINDALL']}),
    new View({id: 5, route: ['role'], requires: ['Role.FINDALL'], menuEntryId: 4}),
    new View({id: 6, route: ['role', ':number'], requires: ['Role.FINDALL']}),
    new View({id: 7, route: ['role', 'new'], requires: ['Role.FINDALL']}),
    new View({id: 23, route: ['forms'], requires: ['Form.FINDALL'], menuEntryId: 15}),
    new View({id: 24, route: ['forms', 'data'], requires: ['FormData.GETUSERFORMSDATA'], menuEntryId: 16}),
    new View({id: 23, route: ['view'], requires: ['View.FINDALL'], menuEntryId: 23}),
    new View({id: 23, route: ['view', 'filled'], requires: ['ViewData.FINDALL'], menuEntryId: 24}),
    /**
     new View({id: 8, route: ['dictamenes'], requires: ['Dictamen.FINDALL'], menuEntryId: 6}),
     new View({id: 9, route: ['dictamenes', 'categoria'], requires: ['CategoriaDictamen.FINDALL'], menuEntryId: 7}),

     new View({id: 10, route: ['dictamenes', 'new'], requires: ['Dictamen.CREATE', 'CategoriaDictamen.FINDALL']}),
     new View({id: 11, route: ['dictamenes', ':number'], requires: ['Dictamen.UPDATE', 'CategoriaDictamen.FINDALL']}),
     */
    new View({id: 12, route: ['repository'], menuEntryId: 8}),
    new View({id: 15, route: ['topic'], requires: ['Topic.FINDALL', 'Topic.FIND', 'Topic.DELETE', 'Topic.UPDATE'], menuEntryId: 13}),
    new View({id: 16, route: ['topic', ':number'], requires: ['Topic.FIND', 'Topic.GET', 'Topic.UPDATE', 'Topic.CREATE']}),
    new View({id: 17, route: ['post'], requires: ['Topic.FINDBYNAME', 'Post.FINDBYTOPIC', 'Post.FINDLASTPOSTS'], menuEntryId: 12}),
    new View({id: 18, route: ['post', ':number', 'edit'], requires: ['Topic.FINDALL', 'Post.CREATE', 'Post.GET', 'Post.UPDATE']}),
    new View({
        id: 19,
        route: ['post', ':number'],
        requires: ['Topic.FINDALL', 'Topic.FIND', 'Post.GET', 'Post.UPDATE', 'Reply.FINDALL', 'Reply.FIND', 'Reply.CREATE', 'Reply.UPDATE']
    }),
    new View({id: 20, route: ['post', ':number', 'reply', ':number'], requires: ['Reply.CREATE', 'Reply.UPDATE', 'Reply.GET', 'Post.GET']}),
    new View({id: 25, route: ['chat'], menuEntryId: 18}),
    new View({id: 26, route: ['ministry'], requires: ['Ministry.FINDALL'], menuEntryId: 19}),
    new View({id: 27, route: ['ministry', ':number'], requires: ['Ministry.CREATE', 'Ministry.UPDATE']}),
    new View({id: 28, route: ['ministry', 'new'], requires: ['Ministry.CREATE']}),
    new View({id: 30, route: ['report-errors'], menuEntryId: 21}),


];



// WEBPACK FOOTER //
// ./src/app/core/domain/view.ts